/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ISoftwareEscrowQueryVariables = Types.Exact<{
  escrowId: Types.Scalars['ID']['input'];
}>;

export type ISoftwareEscrowQuery = {
  __typename?: 'Query';
  softwareEscrow: {
    __typename?: 'SoftwareEscrow';
    status: Types.EscrowStatusEnum;
    activationNotification: boolean;
    agreementSettingsConfigured: boolean;
    id: string;
    currentCompanyRole?: Types.EscrowPartyTypeEnum | null;
    beneficiaryConfigured: boolean;
    depositorConfigured: boolean;
    startedBy: Types.EscrowPartyTypeEnum;
    beneficiaryActivityNotification: Types.ActivityNotificationEnum;
    depositorActivityNotification: Types.ActivityNotificationEnum;
    depositStatus: Types.DepositStatusEnum;
    beneficiaryDisruptionNotification: Types.DisruptionNotificationEnum;
    beneficiaryDisruptionNotificationGracePeriod?: Types.DisruptionNotificationGracePeriodEnum | null;
    depositorDisruptionNotification: Types.DisruptionNotificationEnum;
    depositorDisruptionNotificationGracePeriod?: Types.DisruptionNotificationGracePeriodEnum | null;
    storageRegion?: string | null;
    beneficiarySharedInformation: boolean;
    pendingActivation: boolean;
    reportsEnabled: boolean;
    reportsEnabledAt?: any | null;
    adminReviewAt?: any | null;
    onboardingAt?: any | null;
    signedAt?: any | null;
    activatedAt?: any | null;
    createdAt: any;
    assetVersionsLimit?: number | null;
    depositActivity: any;
    certificationVerified: boolean;
    certificationCertified: boolean;
    requiredContentTypes: Array<Types.ContentTypeEnum>;
    lastDeposit?: any | null;
    userUpdatedAt: any;
    escrowInvitation?: {
      __typename?: 'EscrowInvitation';
      id: string;
      status: Types.InvitationStatusEnum;
      companyName: string;
      partyType: string;
      userName?: string | null;
      userEmail?: string | null;
      user?: { __typename?: 'User'; id: string; name?: string | null; email: string; phone?: string | null } | null;
      policy: { __typename?: 'EscrowInvitationPolicy'; accept: boolean; reject: boolean; update: boolean };
      escrow:
        | { __typename?: 'ContinuityEscrow'; id: string }
        | { __typename?: 'SaasEscrow'; id: string }
        | { __typename?: 'SoftwareEscrow'; id: string };
    } | null;
    escrowTermination?: {
      __typename?: 'EscrowTermination';
      id: string;
      status: Types.EscrowTerminationStatusEnum;
      terminateAt?: any | null;
      requesterParty: Types.EscrowPartyTypeEnum;
      policy: { __typename?: 'EscrowTerminationPolicy'; accept: boolean; reject: boolean };
    } | null;
    agreement: {
      __typename?: 'Agreement';
      agreementForm?: Types.AgreementFormEnum | null;
      id: string;
      jurisdiction?: Types.JurisdictionEnum | null;
      liability?: Types.LiabilityEnum | null;
      approvedByBeneficiary?: boolean | null;
      approvedByCodekeeper?: boolean | null;
      approvedByDepositor?: boolean | null;
      thirdPartyAgreement: boolean;
      updatedAt: any;
      legalContext: Array<Types.LegalContextEnum>;
      legalContextOther?: string | null;
      approved: boolean;
      conditions: Array<Types.AgreementConditionEnum>;
      conditionsOther?: string | null;
      policy: {
        __typename?: 'AgreementPolicy';
        approve: boolean;
        generate: boolean;
        write: boolean;
        download: boolean;
      };
    };
    beneficiary?: {
      __typename?: 'Beneficiary';
      city?: string | null;
      companyName?: string | null;
      companyRegistrationNumber?: string | null;
      companyWebsite?: string | null;
      country?: string | null;
      id: string;
      postalCode?: string | null;
      region?: string | null;
      street?: string | null;
      streetNumber?: string | null;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        email: string;
        name: string;
        phone?: string | null;
        signatory: boolean;
        contactType: Types.ContactTypeEnum;
      }>;
      policy: {
        __typename?: 'BeneficiaryPolicy';
        update: boolean;
        readEscrowMemberships: boolean;
        createEscrowMemberships: boolean;
      };
    } | null;
    depositor?: {
      __typename?: 'Depositor';
      city?: string | null;
      companyName?: string | null;
      companyRegistrationNumber?: string | null;
      companyWebsite?: string | null;
      country?: string | null;
      id: string;
      postalCode?: string | null;
      region?: string | null;
      street?: string | null;
      streetNumber?: string | null;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        email: string;
        name: string;
        phone?: string | null;
        signatory: boolean;
        contactType: Types.ContactTypeEnum;
      }>;
      policy: { __typename?: 'DepositorPolicy'; update: boolean };
    } | null;
    policy: {
      __typename?: 'SoftwareEscrowPolicy';
      activate: boolean;
      createBeneficiary: boolean;
      deferActivation: boolean;
      depositAssets: boolean;
      enableReports: boolean;
      inviteBeneficiary: boolean;
      inviteDepositor: boolean;
      read: boolean;
      remove: boolean;
      requestTermination: boolean;
      update: boolean;
      write: boolean;
      createAgreementSuggestedChange: boolean;
      createBeneficiarySuggestedChange: boolean;
      createDepositSuggestedChange: boolean;
      createDepositorSuggestedChange: boolean;
      createNotificationSuggestedChange: boolean;
      updateBeneficiaryNotifications: boolean;
      updateDepositorNotifications: boolean;
    };
    app: {
      __typename?: 'App';
      id: string;
      name?: string | null;
      owned: boolean;
      logoUrl?: string | null;
      ownerName: string;
      ownerWebsite?: string | null;
    };
  };
};

export const SoftwareEscrowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'softwareEscrow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'softwareEscrow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'softwareEscrowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activationNotification' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agreementSettingsConfigured' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentCompanyRole' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beneficiaryConfigured' } },
                { kind: 'Field', name: { kind: 'Name', value: 'depositorConfigured' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beneficiaryActivityNotification' } },
                { kind: 'Field', name: { kind: 'Name', value: 'depositorActivityNotification' } },
                { kind: 'Field', name: { kind: 'Name', value: 'depositStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beneficiaryDisruptionNotification' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beneficiaryDisruptionNotificationGracePeriod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'depositorDisruptionNotification' } },
                { kind: 'Field', name: { kind: 'Name', value: 'depositorDisruptionNotificationGracePeriod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'storageRegion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beneficiarySharedInformation' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'escrowInvitation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EscrowInvitationFields' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'escrowTermination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EscrowTerminationFields' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agreement' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EscrowAgreementFields' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'beneficiary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeneficiaryFields' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'depositor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DepositorFields' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingActivation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportsEnabledAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EscrowPolicyFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'adminReviewAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onboardingAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assetVersionsLimit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'depositActivity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificationVerified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificationCertified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiredContentTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastDeposit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userUpdatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'app' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'owned' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerWebsite' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContactFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signatory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeneficiaryPolicyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeneficiaryPolicy' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'update' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readEscrowMemberships' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createEscrowMemberships' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DepositorPolicyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DepositorPolicy' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'update' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EscrowInvitationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EscrowInvitation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accept' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'update' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'userName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userEmail' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'escrow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EscrowTerminationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EscrowTermination' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'terminateAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requesterParty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accept' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reject' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EscrowAgreementFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Agreement' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'agreementForm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'liability' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvedByBeneficiary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvedByCodekeeper' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvedByDepositor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thirdPartyAgreement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalContext' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalContextOther' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'approve' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'write' } },
                { kind: 'Field', name: { kind: 'Name', value: 'download' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conditions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conditionsOther' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeneficiaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Beneficiary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyRegistrationNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContactFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeneficiaryPolicyFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DepositorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Depositor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyRegistrationNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContactFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DepositorPolicyFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EscrowPolicyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SoftwareEscrowPolicy' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'activate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createBeneficiary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deferActivation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'depositAssets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inviteBeneficiary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inviteDepositor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'read' } },
          { kind: 'Field', name: { kind: 'Name', value: 'remove' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestTermination' } },
          { kind: 'Field', name: { kind: 'Name', value: 'update' } },
          { kind: 'Field', name: { kind: 'Name', value: 'write' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createAgreementSuggestedChange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createBeneficiarySuggestedChange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createDepositSuggestedChange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createDepositorSuggestedChange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createNotificationSuggestedChange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updateBeneficiaryNotifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updateDepositorNotifications' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ISoftwareEscrowQuery, ISoftwareEscrowQueryVariables>;
